<template>
  <div
:class="[applied ? 'applied' : '', blindAd? 'blind': '',useTemplate ? 'template':'',disabled ? 'disabled':'' ]"
    class="cp-job-detail-card animated fadeIn"
>
    <div class="detail-header detail-section d-none d-lg-block position-relative">
      <div v-if="disabled" class="header-block" />
      <a v-if="showNewTab" :href="`/job/${fullSlug||id}`" target="_blank">
        <span>
          {{ cpLang("jd.view_new_tab") }}
        </span>
      </a>
      <div class="l-flex">
        <ShareCopy :key="getLink()" :content="getLink()" />
        <div class="share-icon">
          <ShareWidget :id="String(id)" :url="getLink()" />
        </div>
        <div class="bookmark-icon">
          <Bookmark :id="String(id)" :source="'preview'" />
        </div>
      </div>
      <!-- <div class="share-icon">
      </div>
      <div class="bookmark-icon">
      </div> -->
    </div>
    <div class="detail-header detail-section d-block d-lg-none" style="padding-top:24px">
      <div v-if="disabled" class="header-block" />
      <MobileShare :id="String(id)" :url="getLink()" />
    </div>
    <div :key="isExpired" :class="isExpired?'expired':''" class="detail-intro text-center">
      <div v-if="!blindAd" :class="!logoName ? 'extra-pad' : ''" class="company-block">
        <div
          v-if="logoName"
          :style="`background-image:url(${logoName});cursor:pointer`"
          @click="toCompanyPage()"
          class="company-img"
        />
        <br v-else>
        <span :style="`cursor:pointer`" @click="toCompanyPage()">{{ companyName }}</span>
      </div>
      <div v-if="blindAd" class="blindCompany company-blcok">
        <div class="text">
          <i>{{ cpLang("jd.blind_company") }}</i>
        </div>
      </div>
      <div v-show="!useTemplate" class="detail-title">
        {{ title }}
      </div>
      <div v-if="tag && Object.keys(tag).length > 0" class="tags-block">
        {{ cpLang("global.tags") }}:
        <div>
          <a v-for="x in tag" :key="x.value" :href="`/SearchJobs?tag=${x.en }`" target="_blank">
            <div class="tags">
              {{ x.default }}
            </div>
          </a>
        </div>
      </div>
      <div :class="useTemplate ? 'tempalte-tab':''" class="tab-block">
        <div :class="currentTab==='job'?'active':''" @click="toggleTab('job')" class="tabs left">
          {{ cpLang("jd.job_details") }}
        </div>
        <div
v-if="!blindAd"
:class="currentTab==='company'?'active':''"
@click="toggleTab('company')"
          class="tabs right"
>
          {{ cpLang("jd.company_overview") }}
        </div>
        <!-- :target="preview ? '_blank' : '_self'" -->
        <a
          v-if="!blindAd && !redirect && !recruitmentDay"
          :class="[applied ? 'applied' : '', btnShow? 'btnShow':(useTemplate ? '': 'btnHide')]"
          :href="'myjob/apply/'+id"
          :disabled="disabled"
          class="apply-now profile-btn"
          target="_blank"
        >
          {{ applied ? cpLang("jd.applied") : cpLang("jd.apply_now") }}
        </a>
        <a v-if="redirect&&externalapplyurl" v-on:click="externalApply" :href="externalapplyurl" target="_blank">
          <div v-if="redirect" :class="[btnShow? 'btnShow':(useTemplate ? '': 'btnHide')]" class="apply-now redirect">
            {{ cpLang("jd.apply_on_company") }}
          </div>
        </a>
        <hr v-if="blindAd">
      </div>
    </div>
    <div v-if="!useTemplate" v-show="currentTab==='job'?true:false" class="detail-content detail-section">
      <div v-html="description" class="description" />
      <div v-html="replyinfo" class="reply-info" />
      <Additional
        :additional="additional"
        :job-pulish-date="jobPublisheddate"
        :industry="industry"
        :industrydesc="industrydesc"
        :shift-type="shifttpeObj"
        :field="field"
      />
      <Interested v-if="showPredict && hasPredict" :id="id" @noPredict="noPredict" />
    </div>
    <div v-if="!useTemplate" v-show="currentTab==='company'?true:false" class="detail-content detail-section">
      <div class="companyInfo detail-table">
        <div v-html="companyIntro" class="companyIntro" />
        <div v-if="companyData" class="company-heading detail-heading">
          {{ cpLang("jd.company_info") }}
        </div>
        <hr>
        <div class="row">
          <template v-for="item in companyData">
            <div v-if="item.value" :key="item.key" class="detail-item company-item col-6">
              <div>
                {{ item.key }}
              </div>
              <div v-if="typeof(item.value) === 'object'">
                <b v-if="checkLang(item.value)">
                  {{ item.value.default }}
                </b>
                <ul v-else>
                  <b v-for="(i) in item.value" :key="i.value">
                    <li>
                      {{ i.default }}
                    </li>
                  </b>
                </ul>
              </div>
              <b v-else>
                {{ item.value }}
              </b>
            </div>
          </template>
        </div>
      </div>
      <CompanyOtherJob v-if="cdata && cdata.positions && cdata.positions[0]" :id="id" :cdata="cdata" />
    </div>

    <div v-if="useTemplate" v-html="template" class="ctemplate">
      <!-- Tempalte -->
    </div>
    <ApplyForm v-if="applying" :job="jobResult" @close="applying=false" @apply="appliedHandle" @login="loginHandle" />
    <ApplyDone v-if="showApplied" :job="jobResult" @close="showApplied=false" />
  </div>
</template>
<script>
import MobileShare from '~/components/search/MobileShare'
import ShareWidget from '~/components/search/ShareWidget'
import ShareCopy from '~/components/search/ShareCopy'
import Bookmark from '~/components/search/Bookmark'
import Interested from '~/components/search/jd/Interested'
import ApplyForm from '~/components/search/jd/ApplyForm'
import Additional from '~/components/search/jd/Additional'
import CompanyOtherJob from '~/components/search/jd/CompanyOtherJob'
import commonHelper from '~/assets/js/commonHelper.js'
import ApplyDone from '~/components/search/jd/ApplyDone'
export default {
  components: {
    ShareWidget,
    ShareCopy,
    Bookmark,
    Interested,
    Additional,
    CompanyOtherJob,
    MobileShare,
    ApplyForm,
    ApplyDone
  },
  props: {
    id: {
      default: null,
      type: String
    },
    pad: {
      default: 0,
      type: Number
    },
    wrapper: {
      default: null,
      type: String
    },
    showNewTab: {
      default: true,
      type: Boolean
    },
    closePreview: {
      default: null,
      type: Function
    },
    showPredict: {
      default: true,
      type: Boolean
    },
    closable: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    preview: {
      default: false,
      type: Boolean
    },
    ssrData: {
      default: null,
      type: Object
    }
  },
  data: function () {
    return {
      cpHost: process.env.cp_host,
      loaded: false,
      hasPredict: true,
      applied: false,
      copied: false,
      single: false,
      blindAd: false,
      redirect: false,
      recruitmentDay: false,
      useTemplate: false,
      isExpired: false,
      notAvailable: false,
      eventAdded: false,
      btnShow: true,
      applying: false,
      copyContent: '',
      externalapplyurl: null,
      currentTab: 'job',
      template: '',
      title: '',
      companyName: '',
      fullSlug: '',
      tag: {},
      replyinfo: '',
      description: '',
      companyIntro: '',
      logoName: null,
      additional: {},
      companyData: {},
      cdata: null,
      industry: null,
      industrydesc: null,
      cluster: null,
      clusterdesc: null,
      field: {},
      miscellaneous: [],
      fullDetail: {},
      showApplied: false,
      jobPublisheddate: 0,
      shifttpeObj: null
    }
  },
  watch: {
    description(val) {
      if (val) {
        const vm = this
        this.$nextTick(() => {
          const text = this.applied ? 'Applied' : 'Apply Now'
          const btns = document.querySelectorAll('.content-apply-now')
          if (btns) {
            for (let i = 0; i < btns.length; i++) {
              if (btns[i]) btns[i].innerText = text
              if (this.applied) btns[i].classList.add('applied')
              btns[i].target = vm.preview ? '_blank' : '_self'
              vm.eventAdded = true
            }
          }
        })
      }
    }
  },
  created() {
    // get data from prop and SSR
    if (this.ssrData) this.parseData()
  },
  async mounted() {
    // popup apply form
    // if ($store.state.user === '#apply' && !this.blindAd && !this.redirect) {
    //   this.applying = true
    // }
    this.hideBtn()
    this.$store.dispatch('loading/setPreview', true) // Set short footer
    // console.log('SSR Check', this.ssrData)
    // Handle API Data
    if (!this.ssrData) {
      this.jobResult = await this.$store.state.jobs.detail
      this.companyResult = await this.$store.state.jobs.company
      this.cdata = await this.$store.state.jobs.companyOther
      this.parseData()
    } else {
      const ssrData = this.ssrData
      this.jobResult = ssrData.jobResult
      this.companyResult = ssrData.companyResult
      this.cdata = ssrData.cdata
      this.parseData()
      // handle
    }
    if (this.isExpired === true && this.isNotAvailable === true) {
      // window.alert('Not Available')
    } else if (this.isExpired) {
      // window.alert('Expired')
    } else {
      //
    }
    this.$emit('loaded')
    this.loaded = true
    const mpFunctions = this.fullDetail.field ? this.fullDetail.field.map((field) => { return field.en }) : false
    const mpSubFunctions = this.fullDetail.field ? this.fullDetail.field.map((field) => { if (field.children) return Object.keys(field.children).map(function(child, idx) { return field.children[child].en }) }).flat() : false
    const mpJobObject = {
      'job id': this.fullDetail.id,
      'job level': (this.fullDetail.manageriallevel && this.fullDetail.manageriallevel.en) || '',
      preview: this.preview,
      industry: this.fullDetail.industrydesc ? this.fullDetail.industrydesc.en : null,
      industryId: this.fullDetail.industry ? this.fullDetail.industry : null,
      cluster: this.fullDetail.clusterdesc ? this.fullDetail.clusterdesc.en : null,
      clusterId: this.fullDetail.cluster ? this.fullDetail.cluster : null,
      function: mpFunctions[0] || '',
      functions: mpFunctions || '',
      'sub function': mpSubFunctions[0] || '',
      'sub functions': mpSubFunctions || '',
      template: this.useTemplate ? 'customized' : 'regular',
      language: 'en'
    }
    this.$gtm.pushEvent({ event: 'jobDetailView', queryString: JSON.stringify(mpJobObject) })
    const event = new Event('loadedJobdetail')
    window.dispatchEvent(event)
    // this.copyContent = await this.getLink()
  },
  beforeDestroy() {
    // this.$store.dispatch('loading/setPreview', false) // Set short footer
    this.hideBtn(true)
    window.removeEventListener('resize', () => {
      window.scrollTo(0, 0)
    })
    // console.log('destroyed')
    const vm = this
    if (vm.eventAdded) {
      const btns = document.querySelectorAll('.content-apply-now')
      if (btns) {
        for (let i = 0; i < btns.length; i++) {
          // btns[i].removeEventListener('click', function () {
          //   vm.applyJob()
          // })
          vm.eventAdded = false
        }
      }
    }
    if (window && window.ps1) window.ps1.destroy()
  },
  methods: {
    toCompanyPage: function() {
      const slug = commonHelper.getSlug(this.companyName)
      const url = '/company-' + slug + '-jobs/1'
      window.location.href = url
    },
    toggleTab: function (tab) {
      this.currentTab = tab
      document.querySelectorAll('.detail-content').forEach((i) => {
        window.scrollTo(0, 0)
      })
    },
    externalApply: function () {
      const headers = { 'Content-Type': 'application/json' }
      this.$axios.put('statistic/' + this.id + '/externalapply', { headers: headers })
    },
    checkLang(item) {
      return Object.prototype.hasOwnProperty.call(item, 'en') && Object.prototype.hasOwnProperty.call(item, 'th')
    },
    languageHandler(item) {
      if (typeof (item) === 'object') {
        return item.default
      } else {
        return item
      }
    },
    getLink() {
      return `${this.cpHost}job/${this.fullSlug}`
    },

    async parseData() {
      const detail = this.ssrData ? this.ssrData.jobResult : this.jobResult
      // console.log(detail)
      const company = this.ssrData ? this.ssrData.companyResult : this.companyResult
      const lang = this.languageHandler
      this.shifttpeObj = {
        key: this.cpLang('jd.shifttype'),
        value: detail.shifttype,
        table: 'right',
        isempty: !detail.shifttype
      }
      this.externalapplyurl = detail.externalapplyurl
      this.tag = detail.tag
      this.title = lang(detail.jobtitletext)
      this.description = detail.description
      this.replyinfo = detail.replyinfo
      this.additional = await detail.additional
      this.jobPublisheddate = detail.publisheddate ? detail.publisheddate.timestamp : 0
      this.logoName = detail.logoname && detail.logoname.indexOf('https') === -1 ? 'https://jobs.getlinks.com/static/logo/' + detail.logoname : detail.logoname
      this.companyIntro = detail.companyintro
      this.companyName = detail.displayname
      this.companyData = company.companyInfo
      this.industrydesc = detail.industrydesc
      this.industry = detail.industry
      this.clusterdesc = detail.clusterdesc
      this.cluster = detail.cluster
      this.field = detail.field
      this.blindAd = detail.blindAd
      this.redirect = detail.redirect
      this.recruitmentDay = detail.recruitmentDay
      this.useTemplate = detail.customTemplateUsed
      this.isExpired = detail.expired
      this.isNotAvailable = detail.notAvailable
      this.applied = detail.applications ? !detail.applications.can_apply : false
      this.fullDetail = detail
      this.miscellaneous = detail.miscellaneous
      this.getFullSlug()
      if (this.useTemplate) this.template = detail.template
      setTimeout(function () {
        const divs = document.querySelectorAll('.tr_hidden')
        for (let i = 0; i < divs.length; ++i) {
          const tag = divs[i].parentNode.parentNode.tagName
          if (tag === 'TR') divs[i].parentNode.parentNode.remove()
        }
      }, 100)
    },
    noPredict() {
      this.hasPredict = false
    },
    checkVisible(elm) {
      const rect = elm.getBoundingClientRect()
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
    },
    checkVisible2(elm) {
      const rect = elm.getBoundingClientRect()
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight) - 500
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
    },
    hideBtn(remove) {
      if (this.useTemplate) {
        return
      }
      const rm = Boolean(remove)
      const vm = this
      if (!rm) {
        window.addEventListener('scroll', function () {
          const elementTarget = document.querySelector('.interested')
          const elementTarget2 = document.querySelector('.additional')
          if (elementTarget) {
            if (vm.checkVisible(elementTarget)) {
              vm.btnShow = false
            } else {
              vm.btnShow = true
            }
          } else if (!elementTarget && elementTarget2) {
            // console.log(vm.checkVisible2(elementTarget2))
            if (vm.checkVisible2(elementTarget2)) {
              vm.btnShow = false
            } else {
              vm.btnShow = true
            }
          } else {
            vm.btnShow = true
          }
        })
      } else {
        window.removeEventListener('scroll', function () {
          const elementTarget = document.querySelector('.interested')
          if (elementTarget) {
            if (vm.checkVisible(elementTarget)) {
              vm.btnShow = false
            } else {
              vm.btnShow = true
            }
          }
        })
      }
    },
    applyJob() {
      if (this.disabled) {
        return false
      }
      // if (this.applied) {
      //   this.showApplied = true
      // } else {
      //   this.applying = true
      // }
      const url = 'myjob/apply/' + this.id
      if (this.preview) {
        window.open('https://www.google.com', '_new')
        // const myWindow = window.open(url, '_blank')
        // myWindow.focus()
      } else {
        window.location.href = url
        // this.$router.push({
        //   path: url
        // })
      }
    },
    appliedHandle() {
      this.applying = false
      this.showApplied = true
      this.applied = true
    },
    getFullSlug() {
      this.fullSlug = commonHelper.getSlug(this.title) + '-' + this.id
    },
    loginHandle() {
      this.applying = false
      // cannot sync the store between client and server
      location.reload()
      // const vm = this
      // // const cookie = this.$cpCookie.getAll()
      // this.$store.state.user.userInfo.token = this.$cpCookie.get('token')
      // const cookie = vm.$cpCookie.getAll()
      // vm.$store.dispatch('user/fetchUser', cookie)
      // console.log(this.$cpCookie.get('token') + '===============================')
      // // await this.$store.dispatch('user/fetchUser', cookie)
      // axios.get(process.env.BASE_API_URL + 'member/', {
      //   headers: {
      //     'X-AUTH-SYNC-TOKEN': this.$cpCookie.get('token')
      //   }
      // }).then(function (response) {
      //   // handle success
      //   console.log(response)
      // const cookie = vm.$cpCookie.getAll()
      // vm.$store.dispatch('user/fetchUser', cookie)
      // }).catch(function (error) {
      //   // handle error
      //   console.log(error)
      // })

      // this.$axios.defaults.headers.common['X-AUTH-SYNC-TOKEN'] = this.$cpCookie.get('token')
      // console.log(this.$axios.defaults.headers.common)
      // const { data } = await this.$axios.get('member/')
      // console.log(data)
      // this.applying = true
    }
  }
}

</script>
